export const Presets = {
  NUM: ' 0123456789',
  ALPHANUM: ' 0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
}
